var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.answersSortedByDate),function(answer){return _c('ForumAnswerItem',{key:answer.id,attrs:{"answer":answer}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }